<!--
@Author: Colin Osterhout <ctosterhout>
@Date:   2019-03-29T10:26:09-08:00
@Email:  ctosterhout@alaska.edu
@Last modified by:   ctosterhout
@Last modified time: 2020-01-20T10:20:26-09:00
@License: Released under MIT License. Copyright 2019 University of Alaska Southeast.  For more details, see https://opensource.org/licenses/MIT
-->

<template>
<div v-show="articles.length > 0"
     class="recent-articles">
  <template v-if="mode === 'homepage'">
    <article v-for="(article, i) in articles"
             :key="i"
             class="card my-3 border-0 rounded-0 bg-dark text-light">
      <h3 class="card-header rounded-0 bg-secondary text-light">
        {{ title }}
      </h3>

      <div class="card-body p-0">
        <img v-if="article.thumbnail"
             :src="article.thumbnail"
             alt=""
             class="card-img rounded-0 img-fluid">
      </div>
      <div class="card-footer mt-4 p-0 rounded-0 border-0 bg-transparent">
        <a :href="article.href"
          class="btn btn-flat btn-primary">
            {{ article.title | striphtml }}
        </a>

        <p class="card-text">{{ article.lead }}</p>
      </div>
    </article>
  </template>
  <template v-else>
    <h2>{{ title }}</h2>
    <div v-for="(article, i) in articles"
         :key="i"
         class="recent-article card rounded-0 my-3">
      <img v-if="article.thumbnail"
           :src="article.thumbnail"
           alt=""
           class="card-img-top rounded-0">
      <div class="card-body">
        <h5 class="card-title"><a :href="article.href">{{ article.title | striphtml }}</a></h5>
      </div>
    </div>
  </template>
</div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>

<script>
import _ from 'lodash'
import loadArticles from '../js/load-articles'
import URI from 'urijs'

export default {
  name: 'RecentArticles',
  props: {
    dataArticlesUrl: {
      type: String,
      required: true
    },
    tags: {
      type: [Array, String],
      required: false
    },
    title: {
      type: String,
      required: false,
      default: 'Recent News'
    },
    limit: {
      type: [String, Number],
      required: false
    },
    mode: {
      type: String,
      required: false,
      default: 'interior',
      validator: function (value) {
        return ['homepage', 'interior'].indexOf(value) > -1
      }
    }
  },
  data: function () {
    return {
      articles: []
    }
  },
  methods: {
    loadArticles: function (url) {
      return loadArticles(url)
    }
  },
  created: function () {
    const that = this
    const uri = URI(location.href)

    this.loadArticles(this.dataArticlesUrl)
      .then(function (articles) {
        // Function to normalize tag by trimming it and converting to lower case
        const formatTag = s => s.trim().toLowerCase()

        // Normalize the tags property; work with either String or Array property
        const tags = _.isString(that.tags)
          ? _.map(that.tags.split(','), formatTag)
          : _.map(that.tags, formatTag)

        // Function which returns true based on the tag property and the
        //  article's tags
        // If there is no tags always return true
        // Otherwise check the intersection of the tags array and the article's
        //  tags to be of greater than zero length
        const filterByTag = _.isEmpty(tags)
          ? () => true
          : article => _.intersection(tags, _.map(article.tag, formatTag)).length > 0

        // Function to filter out the current article from the list
        const filterOutSelf = article => article.href !== uri.pathname()

        // Apply our filter functions to our articles
        const articlesFiltered = _.filter(articles, _.overEvery(filterByTag, filterOutSelf))

        // Figure out how many we really need
        const limitArticles = Number(that.limit) || articles.length

        // Assign articles to component
        that.articles = _.slice(articlesFiltered, 0, limitArticles)

        // Let parent know that we've successfully loaded articles
        that.$emit('loaded', articles.length)
      })
      .catch(function (error) {
        that.$gtm.trackException(`[RecentArticles] Failed to load articles: ${error.message}`)
      })
  },
  components: {}
}
</script>
